<template>
    <div>
        <headtop class="story-header"></headtop>
        <div class="details-back"  @click="goback()">
          <img src="~@/assets/img/story/back.png"/>
        </div>
        <!-- 二维码模块 -->
        <div class="detail-wrapper">
          <div class="detail-box">
            <div class="QRCode" style="width: 350px;height: 390px">
              <canvas id="canvasId" :style="{'width':width, 'height':height}"></canvas>
              <span style="font-size: 26px">微信扫一扫在线观看</span>
            </div>
            <div v-html="descript" class="detail-descript">{{ descript }}</div>
          </div>
        </div>
    </div>
</template>
  <script>
import headtop from "@/components/Headtop.vue"
import QRCode from 'qrcode';//引入生成二维码插件
  export default {
    components: {
        headtop
    },
    props: {
      content: {
        type: String,
        default: "测试二维码"
      },
      width: {
        type: String,
        default: "350"
      },
      height: {
        type: String,
        default: "350"
      },
      codeName: {
        type: String,
        default: "二维码"
      },
      load: {
        type: Boolean,
        default: true
      },
      view: {
        type: Boolean,
        default: true
      }
    },
    data(){
      return{
        descript: '',
        titleId: '',
        title:'',
        date: '',
        address: '',
        link: '',
        image_link: '',
        qrCodeDiv: ''
      }
    },
    created() {
      this.$nextTick(() => {
        this.init();
      });
    },
    mounted() {
      this.titleId = this.$route.query.id
      this.date = this.$route.query.date
      if (this.$route.query.link) {
        this.image_link = this.$route.query.link
        this.init();
      }
      this.loadhtml()
    },
    methods: {
      // 生成二维码
      init() {
        let width = this.width,
            height = this.height;
        QRCode.toCanvas(
            document.getElementById('canvasId'),
            this.image_link,
            { width, height, margin: 1, toSJISFunc: QRCode.toSJIS },
            error => {}
        );
      },
      goback() {
        this.$router.go(-1)
      },
      async loadhtml() {
        let res = await this.api.query('list_website_content', {
          fk_title_id: this.titleId
        })
        if(res.data.data[0]) {
          this.descript = res.data.data[0].content
          this.title = res.data.data[0]._fk_title_id
        } else {
          this.$message.warning('暂无内容')
        }
      }
    }
  }
  </script>
<style lang="scss" scoped="scoped">
 .story-header {
    height: 100px;
    background: #517871;
    border-radius: 0px 0px 0px 0px;
    opacity: 0.6;
    color: #FFFFFF;
    position: relative;
    margin-bottom: 95px;
  }
.details-back {
  cursor: pointer;
  width: 48px;
  height: 48px;
  background: #517871;
  opacity: 0.44;
  position: absolute;
  top: 151px;
  right: 209px;
  border-radius: 50%;
  text-align: center;
  img {
    width: 22px;
    height: 24px;
    margin-top: 11px;
}
}
.detail-wrapper {
  background-image: url('~@/assets/img/story/story.png');
  background-repeat: no-repeat;
  // background-position: top, bottom;
  background-size: 100%;
  height: 1548px;
  overflow: hidden;
  .detail-box {
    text-align: center;
    margin: 0 auto;
    margin-left: 360px;
    margin-right: 358px;
    display: flex;
    #canvasId {
      margin: 1px;
    }
    img {
        width: 300px;
        height: 300px;
        margin-right: 50px;
    }
    .detail-descript {
        margin-top: 10px;
        margin-left: 50px;
        margin-bottom: 79px;
    }
  }
}
</style>